import { fromStatusCodeToGenericError, httpService, WebRequestFactory } from "@pjs/http";
import { apiConfig } from "../../../ApiConfig";
import { IReportInappropriateBody } from "../interfaces/IReportInappropriateBody";

export const sendReport = WebRequestFactory.createPost<string, IReportInappropriateBody, { assetId: string }>({
    errorMapper: fromStatusCodeToGenericError,
    http: httpService,
    responseMapper: (response: Response) => response.json(),
    url: (params) => apiConfig.reportInappropriate(params.assetId)
});
